(() => {
function init(root) {
  if(root.dataset.ready) return;
  root.dataset.ready = 'true';
  const track=root.querySelector('.vt-featured-track');
  const cards=[...track.children];
  if(cards.length<2) return;
  const controls=root.querySelector('.vt-featured-controls');
  const toggle=root.querySelector('[data-toggle]');
  const media=window.matchMedia('(prefers-reduced-motion: reduce)');
  let paused=media.matches, timer=null, hover=false, touch=false;
  function movable(){ return track.scrollWidth > track.clientWidth + 2; }
  function stop(){clearInterval(timer); timer=null;}
  function start(){stop(); if(!paused&&!hover&&!touch&&!root.contains(document.activeElement)&&!document.hidden&&movable()) timer=setInterval(()=>move(1),5000);}
  function update(){toggle.textContent=paused?'Start rotation':'Pause rotation';toggle.setAttribute('aria-pressed',String(paused)); controls.hidden=!movable();start();}
  function move(direction){
    const step=cards[0].getBoundingClientRect().width+20;
    const max=track.scrollWidth-track.clientWidth;
    let next=track.scrollLeft+direction*step;
    if(direction>0 && track.scrollLeft>=max-2) next=0;
    else if(direction<0 && track.scrollLeft<=2) next=max;
    track.scrollTo({left:Math.max(0,Math.min(max,next)),behavior:media.matches?'auto':'smooth'});
  }
  root.querySelector('[data-prev]').addEventListener('click',()=>{move(-1);start();});
  root.querySelector('[data-next]').addEventListener('click',()=>{move(1);start();});
  toggle.addEventListener('click',()=>{paused=!paused;update();});
  root.addEventListener('mouseenter',()=>{hover=true;stop();});
  root.addEventListener('mouseleave',()=>{hover=false;start();});
  root.addEventListener('focusin',stop);
  root.addEventListener('focusout',()=>setTimeout(start,0));
  track.addEventListener('touchstart',()=>{touch=true;stop();},{passive:true});
  track.addEventListener('touchend',()=>{touch=false;start();},{passive:true});
  track.addEventListener('touchcancel',()=>{touch=false;start();},{passive:true});
  track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
  document.addEventListener('visibilitychange',start);
  window.addEventListener('resize',update);
  media.addEventListener('change',()=>{paused=media.matches;update();});
  update();
}
document.querySelectorAll('[data-vt-featured]').forEach(init);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-vt-featured]').forEach(init));
})();